import { Space, Row, Col, Image, Typography, Tag } from "antd";
import GroupKind from "~/components/groups/GroupKind";
import GroupMemberCount from "~/components/groups/GroupMemberCount";

const { Title, Text } = Typography;

const SIZE_CONFIGS = {
  sm: {
    logoSize: 80,
    logoGap: 15,
    nameLevel: 5,
  },
  md: {
    logoSize: 108,
    logoGap: 20,
    nameLevel: 4,
  }
};

const GroupProfile = ({ group, size = "sm" }) => {
  const sizeConfig = SIZE_CONFIGS[size];

  return (
    <Row align="middle" wrap={false}>
      <Col flex={`${sizeConfig.logoSize + sizeConfig.logoGap}px`} style={{ textAlign: "left" }}>
        <Image src={group.logo.url} preview={false} width={sizeConfig.logoSize} height={sizeConfig.logoSize} style={{ borderRadius: "8px" }} />
      </Col>
      <Col flex="auto">
        <Space direction="vertical" size={7} style={{ display: "flex" }}>
          <Row>
            <Title level={sizeConfig.nameLevel} style={{ marginBottom: 0 }} title={group.name} ellipsis>{group.name}</Title>
          </Row>
          <Row gutter={10}>
            <Col><GroupKind group={group} /></Col>
            <Col><GroupMemberCount group={group} /></Col>
          </Row>
          <Row gutter={[5, 5]}>
            {group.tags && group.tags.map(tag => <Tag key={tag.id} color="#e3e3e3" style={{ color: "#828282" }}>{tag.name}</Tag>)}
          </Row>
        </Space>
      </Col>
    </Row>
  );
};

export default GroupProfile;
